/**
 * Returns a zoom percentage based on the given value.
 * The value is multiplied by 100, rounded to the nearest integer, and then subtracted by 100.
 * The resulting value is the zoom percentage.
 * @param {number} value - The value to calculate the zoom percentage from.
 * @returns {number} - The calculated zoom percentage.
 */
function getZoomPercentage(value: number) {
  return `${Math.round(value * 100) - 100}%`;
}

export const getZoomAnalyticsValues = (prevZoom: number, nextZoom: number) => {
  const zoomParams = {};
  if (prevZoom < nextZoom) {
    zoomParams.zoom_in = true;
  } else {
    zoomParams.zoom_out = true;
  }
  return {
    value: getZoomPercentage(nextZoom),
    ...zoomParams,
  };
};
